import React from "react";
import Fixed from "../assets/ipillion/Fixed";
import Classic from "../assets/ipillion/Classic";
import Tender from "../assets/ipillion/Tender";
import { useTranslations } from "next-intl";
import Section_name from "./Section_name";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useRouter } from "next/router";
const Auctions_slider = () => {
  const slider = [1, 2, 3];
  const t = useTranslations("ipillion.AuctionsSlider");
  const svg = {
    Fixed: <Fixed />,
    Classic: <Classic />,
    Tender: <Tender />,
    // Seller: <Seller />,
    // Buyer: <Buyer />,
  };
  const router = useRouter();

  return (
    <div className="overflow-hidden mt-[96px] w-[100%] ">
      <Section_name name={t("text")} color={"#D60014"} />
      <Swiper
        key={router.locale}
        slidesPerView={1}
        spaceBetween={23}
        breakpoints={{
          330: { slidesPerView: 1, spaceBetween: 24 },
          430: { slidesPerView: 1.2, spaceBetween: 24 },
          633: { slidesPerView: 1.7, spaceBetween: 24 },
          949: { slidesPerView: 2, spaceBetween: 26 },
          1261: { slidesPerView: 3, spaceBetween: 26 },
        }}
        onSwiper={(swiper) => (next = swiper)}
        className="relative lg:h-[240px] h-[200px]"
      >
        {slider.map((element, index) => {
          const bg = t(`slider.${index}.bg`);
          return (
            <SwiperSlide className="lg:w-[373px] lg:h-[240px] w-[305px] h-[200px]  lg:rounded-[50px_0px_50px_0px] rounded-[32px_0px] lg:mr-auto bg-[#FFFFFF] lg:pr-3 pr-0 mr-0">
              <div className="flex flex-col justify-center pl-[32px]  pt-[32px] ">
                <div
                  className={` lg:h-[72px] lg:w-[72px] h-[60px] w-[60px] rounded-[50%] flex justify-center items-center mb-[16px]`}
                >
                  <label>{svg[t(`slider.${index}.logo`)]}</label>
                </div>
                <h1 className="pb-[8px] text-[24px] leading-[24px] font-[600]">
                  {t(`slider.${index}.title`)}
                </h1>
                <div className="max-w-[241px] lg:max-w-[310px]">
                  <h1 className="lg:text-[18px] text-[14px] font-[400] leading-[20px] w-fit  lg:leading-[26px]">
                    {t(`slider.${index}.descrption`)}
                  </h1>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Auctions_slider;
